import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { AlertsActions } from '../../../../store';
import { Spinner } from '../../../Spinner';
import { Notification } from '../../../Notification';
import { ConnectedInformationGraphDashboard } from './components/InformationGraphDashboard';
import { ConnectedInformationCommentsDashboard } from './components/InformationCommentsDashboard';

import './EventInformationDashboard.css';
import { withRouter } from 'react-router-dom';
import { BackButton } from '../../../BackButton';

export class EventInformationDashboard extends Component {
  input = React.createRef();

  componentDidMount() {
    document.title = 'Parity | Incident Details';

    this.getIncident();
  }

  copyText = () => {
    const { current } = this.input;
    if (current) {
      current.select();
      document.execCommand('copy');
    }
  };

  getIncident = () => {
    const { selectedBuilding, getIncidentDetails } = this.props;
    const { search } = this.props.location;

    const params = queryString.parse(search);
    const { id = '' } = params;

    getIncidentDetails(selectedBuilding.identifier, id);
  };

  closeIncident = () => {
    const {
      navigationParams: {
        selectedSubCategory: { url: selectedSubCategoryUrl },
      },
    } = this.props;

    this.props.history.push(`${selectedSubCategoryUrl}`);
  };

  renderGraph = () => {
    const { selectedIncident } = this.props;

    if (selectedIncident.context_data_api_location) {
      return <ConnectedInformationGraphDashboard dataApiLocation={selectedIncident.context_data_api_location} />;
    }
  };

  renderMostRecentEvents = () => {
    return (
      <div className="event-information__legend-item">
        <Notification type="info" message="No recent events to show." />
      </div>
    );
  };

  renderComments = () => {
    const {
      selectedIncident: { comments, comments_api_location: commentsApiLocation },
    } = this.props;

    if (commentsApiLocation) {
      return (
        <ConnectedInformationCommentsDashboard
          comments={comments}
          commentApiLocation={commentsApiLocation}
          triggerRefetch={this.getIncident}
        />
      );
    }
  };

  render() {
    const {
      selectedIncident: { name },
      isLoading,
      selectedBuilding,
    } = this.props;

    const headerTitleDesktop = `Incident details - ${selectedBuilding.name} ${name}`;
    const headerTitleMobile = `Incident details - ${name}`;
    const desktopOnlyColumnClass = 'equal-width desktop-only';

    if (isLoading) {
      return (
        <div className="event-information--loading">
          <Spinner />
        </div>
      );
    }

    return (
      <div className="event-information">
        <div className="event-information__header">
          <BackButton onClick={() => this.closeIncident()} />
          <div className="event-information__header-title">
            {window.innerWidth < 599 ? headerTitleMobile : headerTitleDesktop}
          </div>
        </div>
        <div className="event-information__main">
          {/* <div className="event-information__shareable-link-section">
            <div className="event-information__link-div">
              <div className="event-information__link-wrapper">
                <input
                  className="event-information__link"
                  type="text"
                  value={shareableUrl}
                  ref={this.input}
                  readOnly={true}
                />
              </div>
              <button className="event-information__button-copy" onClick={this.copyText}>
                <div className="event-information__button-text">{copyButtonText}</div>
              </button>
            </div>
          </div> */}
          {this.renderGraph()}
          <div className="event-information__events-section">
            <div className="event-information__legend">
              <div className="event-information__legend-header">
                <div className="event-information__legend-title">Most recent events</div>
              </div>
              <div className="event-information__column-names">
                <div className="equal-width">Data tag</div>
                <div className="equal-width">Operator</div>
                <div className="equal-width">Value</div>
                <div className={desktopOnlyColumnClass}>Rolling avg minutes</div>
                <div className={desktopOnlyColumnClass}>Message</div>
              </div>
              {this.renderMostRecentEvents()}
            </div>
          </div>
          <div className="event-information__comments-section">
            <div className="event-information__legend">
              <div className="event-information__legend-header">
                <div className="event-information__legend-title">Comments</div>
              </div>
              {this.renderComments()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    isLoading: state.alertsReducer.isLoadingIncident,
    selectedIncident: state.alertsReducer.selectedIncident,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    navigationParams: state.buildingReducer.navigationParams,
  };
}

const mapDispatchToProps = {
  getIncidentDetails: AlertsActions.getIncidentDetails,
};

const EventInformationDashboardWithRouter = withRouter(EventInformationDashboard);
export const ConnectedEventInformationDashboardWithRouter = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventInformationDashboardWithRouter);
